<template>
  <div></div>
</template>
<script>
import { mapState } from "vuex";
import Service from "@/services";

export default {
  components: {},
  data: () => ({}),
  created() {
    /*
    this.$router.push({
      name: "dash",
      query: { s: this.$route.query.s, e: this.$route.query.e }
    });
    */
    window.location.href =
      "/dash?s=" + this.$route.query.s + "&e=" + this.$route.query.e;
  }
};
</script>
